import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom";
import ConfirmApprovedModel from "./ConfirmApprovedModel";
import ConfirmRejectModel from "./ConfirmRejectModel";
import PropTypes from "prop-types";
const token = localStorage.getItem('authToken');
class EditOrganisations extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            textInput: [],
            userName: "",
            title: "",
            category: "",
            areaInput: "",
            categoryData: [],
            currentImageUrls: [],
            existingImages: [],
            submissionStatus: null,
            submeet: false,
            errors: [],
            city: "",
            date: '',
            price: 0,
            city: '',
            pincode: 0,
            isDateValid: true,
            maxSize: 5 * 1024 * 1024, // 5MB in bytes
        };
    }

    async componentDidMount() {
        const { match } = this.props;
        if (match && match.params && match.params.id) {
            const { id } = match.params;
            this.setState({ id });
            await this.userData(id);
        } else {
            console.error("No match params found.");
        }
      
    }

    userData = async (id) => {
    

        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/organisations/${id}`,{
               
                    headers: {
                      Authorization: `Bearer ${token}`, 
                    }
                
            });
            console.log(response.data);
            if (response) {
                console.log(response.data);

                this.setState({
                    title: response.data.title,
                 
                    areaInput: response.data.description,
                    existingImages: response.data.images.map(image => `https://uma-classees.blr1.digitaloceanspaces.com/${image}`),
                  
                    city: response.data.city,
                   
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

 
    handleChange = (e) => {
        const files = Array.from(e.target.files);
        const errors = [];

        const selectedImages = files.filter((file) => {
            const isValidSize = file.size <= this.state.maxSize;
            if (!isValidSize) {
                errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
            }
            return isValidSize;
        });

        this.setState({
            textInput: selectedImages,
            currentImageUrls: selectedImages.map((file) => URL.createObjectURL(file)),
            errors,
        });
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        this.setState({ submeet: true });

        const { textInput, existingImages, title, areaInput, city, pincode, category, date } = this.state;
        const { id } = this.props.match.params;

        try {
            const formData = new FormData();
            if (textInput.length > 0) {
                textInput.forEach((file) => {
                    formData.append('images', file);
                });
            } else {
                existingImages.forEach((url) => {
                    formData.append('existingImages', url);
                });
            }
            formData.append('title', title);
            formData.append('description', areaInput);
          
            formData.append('city', city);
       

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                  
                          Authorization: `Bearer ${token}`, 
                  
                },
            };

            const response = await axios.put(`https://samaj.aasmo.in/api/admin/organisations/${id}`, formData, config);

            if (response.status === 200) {
                this.setState({ submissionStatus: 'success', submeet: false });
                setTimeout(() => {
                this.props.history.push("/organisationslist");
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            this.setState({ submissionStatus: 'error' });
        }
    };


    render() {
        const { textInput, showModal, selectedCategoryId,existingImages,currentImageUrls, errors, showModalReject, isDateValid, date, title, currentImageUrl, city, userName, category, categoryData, submeet, areaInput, submissionStatus } = this.state;
        const isNameValid = userName.trim().length > 0;
        const isTitleValid = title.trim().length > 0;
        const isCityValid = city?.trim().length > 0;

        return (
            <div className="col-md-12">
            <div className="card">
                <div className="header">
                    <h2>Edit Organisations</h2>
                </div>
                <div className="body">
                    <form onSubmit={this.handleSubmit}>
                        <div className="form-group">
                            <label>Title</label>
                            <input
                                className={`form-control ${!isTitleValid && submeet && "parsley-error"}`}
                                value={title}
                                name="title"
                                required=""
                                type="text"
                                onChange={(e) => {
                                    this.setState({ title: e.target.value });
                                }}
                            />
                            {!isTitleValid && submeet ? (
                                <ul className="parsley-errors-list filled">
                                    <li className="parsley-required">
                                        This value is required.
                                    </li>
                                </ul>
                            ) : null}
                        </div>

                 
                        <div className="form-group">
                            
    <label>Image</label>
    
    {(textInput.length > 0 ? currentImageUrls : existingImages).map((imageUrl, index) => (
        <div key={index}>
            <img src={imageUrl} alt={`Image ${index}`} style={{ width: '100px', marginBottom: '10px' }} />
        </div>
    ))}
    <input
        type="file"
        className={`form-control ${!textInput.length && submeet && "parsley-error"}`}
        name="textInput"
        multiple
        onChange={this.handleChange}
    />
    {!textInput.length && submeet ? (
        <ul className="parsley-errors-list filled">
            <li className="parsley-required">This value is required.</li>
        </ul>
    ) : null}

    {errors.length > 0 && (
        <ul className="parsley-errors-list filled">
            {errors.map((error, index) => (
                <li key={index} className="parsley-required">{error}</li>
            ))}
        </ul>
    )}
</div>


                <div className="form-group">
                            <label>City</label>
                            <textarea
                                className={`form-control ${city === "" && submeet && "parsley-error"
                                    }`}
                                value={city}
                                cols="30"
                                name="city"
                                required=""
                                rows="5"
                                onChange={(e) => {
                                    this.setState({ city: e.target.value });
                                }}
                            ></textarea>
                            {city === "" && submeet ? (
                                <ul className="parsley-errors-list filled" id="parsley-id-29">
                                    <li className="parsley-required">
                                        This value is required.
                                    </li>
                                </ul>
                            ) : null}
                        </div>


                        <div className="form-group">
                            <label>Description</label>
                            <textarea
                                className={`form-control ${areaInput === "" && submeet && "parsley-error"
                                    }`}
                                value={areaInput}
                                cols="30"
                                name="textarea"
                                required=""
                                rows="5"
                                onChange={(e) => {
                                    this.setState({ areaInput: e.target.value });
                                }}
                            ></textarea>
                            {areaInput === "" && submeet ? (
                                <ul className="parsley-errors-list filled" id="parsley-id-29">
                                    <li className="parsley-required">
                                        This value is required.
                                    </li>
                                </ul>
                            ) : null}
                        </div>

                        {submissionStatus === 'success' && (
                            <div className="alert alert-success" role="alert">
                                Form submitted successfully!
                            </div>
                        )}

                        <button className="btn btn-primary" type="submit">
                            Submit
                        </button>
                    </form>
                </div>
            </div>
        </div>
        );
    }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, { notifyGeneralInfo })(withRouter(EditOrganisations)); // Wrap with withRouter
